<template>
  <div>
    <template v-for="field in fields">
      <RangeInput v-if="field.type == 'range-input'" :fields="field" />
      <ValueHelpWrapper
        v-else-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput v-else v-bind="field" />
    </template>
  </div>
</template>

<script>
import RangeInput from './wrapper/RangeInput'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import { tableFilterFields } from './lib/tableFilterFields'

export default {
  components: {
    RangeInput,
    ValueHelpWrapper,
  },
  mixins: [tableFilterFields],
  props: {
    formValues: {},
    fullObjects: {},
  },
  emits: ['update:formValues', 'update:fullObjects'],
  computed: {
    fields() {
      return this.tableFilterFields.filter(field => field.isShow)
    }
  }
}
</script>
